(function ($) {

    let close = document.querySelector('.StvHeader-navbar_close_icon');
    let open = document.querySelector('.StvHeader-navbar_open_icon');
    let menu = document.querySelector('.nav-main');
    let navbar = document.getElementById('StvHeader-navbar_icon');
    let sticky = navbar.offsetTop;

    close.addEventListener('click', function () {
        menu.classList.toggle('StvHeader-nav_main--close');
        open.classList.toggle('StvHeader-navbar_open_icon--nodisplay');
        navbar.style.display = 'flex';
    });

    open.addEventListener('click', function () {
        menu.classList.toggle('StvHeader-nav_main--close');
        open.classList.toggle('StvHeader-navbar_open_icon--nodisplay');
        navbar.style.display = 'none';
    });

})(jQuery);